import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import {FormatMessageFunction, LinkProp} from '@fo/shared-types';

export const getMenuLinks = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const menuLinks = [
    {
      label: formatMessage({id: 'footer.column.businessLoans.link'}),
      href: formatMessage({id: 'footer.column.businessLoans.href'}),
      testId: 'ui.footer.link.businessLoans',
    },
    {
      label: formatMessage({id: 'footer.column.FAQ.link'}),
      href: formatMessage({id: 'footer.column.FAQ.href'}),
      testId: 'ui.footer.link.faq',
    },
    {
      label: formatMessage({id: 'footer.column.careers.link'}),
      href: getPageRoute('careers'),
      testId: 'ui.footer.link.careers',
    },
    {
      label: formatMessage({id: 'footer.column.bcr.link'}),
      href: formatMessage({id: 'footer.column.bcr.href'}),
      testId: 'ui.footer.link.bcr',
    },
  ];
  return menuLinks;
};

export const getLegalLinks = (formatMessage: FormatMessageFunction, isAdvisor = false): LinkProp[] => {
  const legalLinks = [
    {
      label: formatMessage({id: 'footer.column.termsOfService.link'}),
      href: formatMessage({id: 'footer.column.termsOfService.href'}),
      testId: 'ui.footer.link.termsOfService',
    },
    ...(isAdvisor
      ? [
          {
            label: formatMessage({id: 'footer.column.advisorsTermsOfBusiness.link'}),
            href: getPageRoute('advisorTerms'),
            testId: 'ui.footer.link.advisorsTermsOfBusiness',
          },
        ]
      : []),
    {
      label: formatMessage({id: 'footer.column.treatingCustomersFairly.link'}),
      href: formatMessage({id: 'footer.column.treatingCustomersFairly.href'}),
      testId: 'ui.footer.link.treatingCustomersFairly',
    },
    {
      label: formatMessage({id: 'footer.column.complaints.link'}),
      href: formatMessage({id: 'footer.column.complaints.href'}),
      testId: 'ui.footer.link.complaints',
    },
    {
      label: formatMessage({id: 'footer.column.cookiesSettings'}),
      href: '#',
      onClick: () =>
        window.OneTrust?.ToggleInfoDisplay
          ? window.OneTrust.ToggleInfoDisplay()
          : () => {
              /* noop */
            },
      testId: 'ui.footer.link.cookiesSettings',
    },
  ];
  return legalLinks;
};

export const getInTouchLinks = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const getInTouch = [
    {
      label: formatMessage({id: 'phoenix.contact.email'}),
      href: `mailto:${formatMessage({id: 'phoenix.contact.email'})}`,
      testId: 'ui.footer.link.contact',
    },
    {
      label: formatMessage({id: 'footer.column.getInTouch.telephone'}),
      href: `tel:${formatMessage({id: 'phoenix.contact.phoneNumber.withCountryCode'})}`,
      testId: 'ui.footer.link.getInTouch',
    },
  ];
  return getInTouch;
};
